var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDC134",
    fillRule: "evenodd",
    d: "M12.403 6H7.286v3.857H6v1.714h1.286v.858H6v1.714h1.286V18h5.117a6.03 6.03 0 0 0 5.631-3.857h1.252v-1.714h-.875a6 6 0 0 0 0-.858h.875V9.857h-1.252A6.04 6.04 0 0 0 12.403 6m4.286 6.429a4.2 4.2 0 0 0 0-.858H9v.858h7.693zM9 14.143v2.143h3.309a4.42 4.42 0 0 0 3.814-2.143zm0-4.286h7.127a4.43 4.43 0 0 0-3.814-2.143H9z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.22769e8316efa52d21ba708e1e4b1dc3.svg";
export { ForwardRef as ReactComponent };